import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { TID } from '@/constants/testIds';

const LOGO = '/kickard-shield.png';

export default function SplashScreen({ onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 1900);
    return () => clearTimeout(t);
  }, [onDone]);

  // Generate sparks once
  const sparks = Array.from({ length: 14 }).map((_, i) => ({
    left: Math.random() * 100,
    delay: Math.random() * 1.5,
    duration: 1.6 + Math.random() * 1.4,
    size: 3 + Math.random() * 3,
  }));

  return (
    <div data-testid={TID.splash} className="kickard-frame stadium-bg flex flex-col items-center justify-center relative overflow-hidden">
      {sparks.map((s, i) => (
        <motion.div
          key={i}
          className="spark"
          initial={{ y: '110%', opacity: 0 }}
          animate={{ y: '-10%', opacity: [0, 1, 1, 0] }}
          transition={{ duration: s.duration, delay: s.delay, ease: 'easeOut' }}
          style={{ left: `${s.left}%`, width: s.size, height: s.size }}
        />
      ))}
      <motion.img
        initial={{ scale: 0.6, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
        src={LOGO}
        alt="Kickard"
        style={{ width: '70%', maxWidth: 290, background: 'transparent' }}
      />
      <motion.div
        initial={{ opacity: 0, letterSpacing: '0.6em' }}
        animate={{ opacity: 1, letterSpacing: '0.4em' }}
        transition={{ delay: 0.5, duration: 0.7 }}
        className="mt-6 font-heading"
        style={{ color: 'hsl(var(--k-gold))', fontSize: 14, letterSpacing: '0.4em' }}
      >
        FOOTBALL × CARDS × ESPORTS
      </motion.div>
    </div>
  );
}
